require('./currencies-new-container.scss')

module.exports = {
  template: require('./currencies-new-container.pug')()
  controller: require('./currencies-new-container.ctrl')
}
